/* ═══════════════════════════════════════════════
   Pre-checkout eligibility form — Coli-Shield
   ═══ FIX BUILD: opt-out path now writes pre_checkout_data
       + applies COLISHIELD26 fallback, so opt-out customers
       are no longer trapped. Diagnostic logs kept for testing.
   ═══════════════════════════════════════════════ */

console.log("🟣 PRE-CHECKOUT.js (FIX BUILD) loaded on:", window.location.pathname,
  "| pre_checkout_completed =", localStorage.getItem('pre_checkout_completed'),
  "| pre_checkout_data present =", localStorage.getItem('pre_checkout_data') ? "yes" : "no");

// ────────── Validation helpers ──────────

function setupErrorMessages() {
  const form = document.getElementById('eligibility-form')
  const inputs = form.querySelectorAll('[aria-required="true"]')
  inputs.forEach(input => {
    const errorDiv = document.createElement('small')
    errorDiv.className = 'contact__field-error hidden'
    errorDiv.id = `${input.id}-error`
    errorDiv.innerHTML = `
      <span class="visually-hidden">Error</span>
      <span class="form__message">This field is required</span>
    `
    let container = input.closest('.field') || input.closest('.field-checkbox')
    if (!container) container = input.parentElement.parentElement
    container.appendChild(errorDiv)
  })
}
setupErrorMessages()

function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}
function isValidPhone(phone) {
  return /^[\d\s\-\+\(\)]+$/.test(phone) && phone.replace(/\D/g, '').length >= 7
}
function getErrorMessage(input) {
  const value = input.value.trim()
  if (!value) return 'This field is required'
  if (input.type === 'email') return !isValidEmail(value) ? 'Please enter a valid email address' : null
  if (input.type === 'tel') return !isValidPhone(value) ? 'Please enter a valid phone number' : null
  return null
}
function isElementHidden(el) {
  while (el && el !== document.body) {
    if (el.style.display === 'none') return true
    if (el.classList && el.classList.contains('hidden')) return true
    el = el.parentElement
  }
  return false
}

function validateFormInputs(form) {
  const requiredInputs = form.querySelectorAll('[aria-required="true"]')
  let isValid = true
  let firstInvalidInput = null

  requiredInputs.forEach(input => {
    if (isElementHidden(input)) return

    if (input.id === 'terms_accepted' && input.disabled) {
      const errorEl = document.getElementById('terms_accepted-error')
      input.setAttribute('aria-invalid', true)
      if (errorEl) {
        errorEl.classList.remove('hidden')
        const msg = errorEl.querySelector('.form__message')
        if (msg) msg.textContent = 'Please open and read the Terms & Conditions first'
      }
      isValid = false
      if (!firstInvalidInput) firstInvalidInput = input
      return
    }

    let isInvalid = false
    let errorMessage = 'This field is required'

    if (input.type === 'checkbox') {
      isInvalid = !input.checked
    } else {
      const value = input.value.trim()
      isInvalid = !value
      if (!isInvalid) {
        const customError = getErrorMessage(input)
        if (customError) { isInvalid = true; errorMessage = customError }
      }
    }

    const errorEl = document.getElementById(`${input.id}-error`)
    input.setAttribute('aria-invalid', isInvalid)
    if (isInvalid) { input.style.borderColor = '#dc2626'; input.classList.add('error') }
    else { input.style.borderColor = ''; input.classList.remove('error') }
    if (errorEl) {
      errorEl.classList.toggle('hidden', !isInvalid)
      if (isInvalid) { const m = errorEl.querySelector('.form__message'); if (m) m.textContent = errorMessage }
    }
    if (isInvalid) { isValid = false; if (!firstInvalidInput) firstInvalidInput = input }
  })

  return { isValid, firstInvalidInput }
}

// ────────── DOM helpers ──────────

function setVisible(id, visible) {
  const el = document.getElementById(id)
  if (el) el.style.display = visible ? '' : 'none'
}
function collectFormData(formId) {
  const data = {}
  document.getElementById(formId).querySelectorAll('input, select, textarea').forEach(el => {
    if (el.type === 'checkbox') data[el.name] = el.checked ? 'on' : ''
    else if (el.name) data[el.name] = el.value
  })
  return data
}
function clearFields(id) {
  const el = document.getElementById(id)
  if (el) el.querySelectorAll('input, select, textarea').forEach(f => {
    if (f.type === 'checkbox') { if (f.id !== 'terms_accepted') f.checked = false }
    else f.value = ''
  })
}
function setColicFormVisible(visible) {
  const form = document.getElementById('colic-form')
  if (!form) return
  if (!visible) form.querySelectorAll('input, select').forEach(f => { f.value = '' })
  form.classList.toggle('hidden', !visible)
  form.querySelectorAll('[aria-required]').forEach(f => f.setAttribute('aria-required', String(visible)))
}

// ────────── Gastric ulcers sub-logic ──────────

function checkGastricLogic() {
  const gastricVal = (document.getElementById('gastric-ulcers')?.value || '').trim()
  const gradeVal = (document.getElementById('gastric-grade')?.value || '').trim()
  const grade4Val = (document.getElementById('gastric-grade4-status')?.value || '').trim()

  const isYes = gastricVal === 'yes'

  setVisible('gastric-grade-section', isYes)
  const gradeSelect = document.getElementById('gastric-grade')
  if (gradeSelect) gradeSelect.setAttribute('aria-required', String(isYes))
  if (!isYes) {
    if (gradeSelect) gradeSelect.value = ''
    const g4 = document.getElementById('gastric-grade4-status')
    if (g4) g4.value = ''
  }

  const isGrade4 = isYes && gradeVal === 'grade4'
  setVisible('gastric-grade4-section', isGrade4)
  const g4Select = document.getElementById('gastric-grade4-status')
  if (g4Select) g4Select.setAttribute('aria-required', String(isGrade4))
  if (!isGrade4 && g4Select) g4Select.value = ''

  let gastricOutcome = 'continue'
  if (isYes && gradeVal) {
    if (gradeVal === 'grade4') {
      if (grade4Val === 'current') gastricOutcome = 'ineligible'
      else if (grade4Val === 'resolved') gastricOutcome = 'needs_review'
    } else {
      gastricOutcome = 'needs_review'
    }
  } else if (isYes && !gradeVal) {
    gastricOutcome = 'waiting'
  }

  setVisible('gastric-review-message', gastricOutcome === 'needs_review')
  setVisible('gastric-ineligible-message', gastricOutcome === 'ineligible')

  return gastricOutcome
}

// ────────── Sound Health free text ──────────

function checkHealthDetails() {
  const val = (document.getElementById('current-health-status')?.value || '').trim()
  const show = val === 'no'
  setVisible('health-details-section', show)
  const textarea = document.getElementById('health_details')
  if (textarea) textarea.setAttribute('aria-required', String(show))
}

// ────────── Main eligibility check ──────────

function checkEligibility() {
  if (!document.getElementById('eligibility-form')) return

  checkHealthDetails()
  const gastricOutcome = checkGastricLogic()

  const steps = [
    { containerId: 'h2-age-health' },
    { containerId: 'q-horse-age-valid',       selectId: 'horse-age-valid' },
    { containerId: 'q-current-health-status', selectId: 'current-health-status' },
    { containerId: 'q-no-ongoing-treatment',  selectId: 'no-ongoing-treatment' },
    { containerId: 'q-gastric-ulcers',        selectId: 'gastric-ulcers', type: 'gastric' },
    { containerId: 'q-foaling',               selectId: 'foaling-7days' },
    { containerId: 'q-anaesthetic',           selectId: 'anaesthetic-7days' },
    { containerId: 'h2-medical-history' },
    { containerId: 'q-no-major-illnesses',    selectId: 'no-major-illnesses' },
    { containerId: 'medical-q2',              selectId: 'no-current-medications' },
    { containerId: 'medical-q3',              selectId: 'colic-assessment-needed', type: 'colic' },
    { containerId: 'h2-location-usage' },
    { containerId: 'q-location-compatible',   selectId: 'location-compatible' },
    { containerId: 'location-q2',             selectId: 'intended-usage-allowed' },
  ]

  let triggeredIndex = -1
  let triggeredType = null

  for (let i = 0; i < steps.length; i++) {
    const { selectId, type } = steps[i]
    if (!selectId) continue

    const el = document.getElementById(selectId)
    if (!el || el.value === '') continue

    if (type === 'gastric') {
      if (gastricOutcome === 'ineligible') {
        triggeredIndex = i
        triggeredType = 'gastric-ineligible'
        break
      }
      continue
    }

    if (type === 'colic') {
      if (el.value === 'yes') {
        triggeredIndex = i
        triggeredType = 'colic'
        break
      }
      continue
    }

    if (el.value === el.getAttribute('data-ineligible-value')) {
      triggeredIndex = i
      triggeredType = 'ineligible'
      break
    }
  }

  steps.forEach(({ containerId }, i) => {
    const hide = triggeredIndex !== -1 && i > triggeredIndex
    const el = document.getElementById(containerId)
    if (hide && el && el.style.display !== 'none') clearFields(containerId)
    setVisible(containerId, !hide)
  })

  const isTriggered = triggeredIndex !== -1
  const isColic = triggeredType === 'colic'

  setColicFormVisible(isColic)
  setVisible('colic-review-message', isColic)

  setVisible('medical-ineligible-section', isTriggered && !isColic)
  setVisible('eligibility-next-btn', !isTriggered || isColic)

  const eligibleSection = document.getElementById('eligible-details-section')
  if (isTriggered && !isColic && eligibleSection && eligibleSection.style.display !== 'none') {
    clearFields('eligible-details-section')
  }
  setVisible('eligible-details-section', !isTriggered || isColic)

  if (isTriggered && !isColic) {
    const btn = document.getElementById('medical-ineligible-proceed')
    if (btn) btn.dataset.eligibleValue = 'no'
  }
  if (isColic) {
    const btn = document.getElementById('medical-ineligible-proceed')
    if (btn) btn.dataset.eligibleValue = 'pending'
  }
}

// ────────── Form submission ──────────

document.getElementById('eligibility-form').addEventListener('submit', async (e) => {
  e.preventDefault()
  console.log("🟣 ELIGIBILITY FORM submit fired");
  const { isValid, firstInvalidInput } = validateFormInputs(e.target)
  if (!isValid) { firstInvalidInput.focus(); return }

  const gastricOutcome = checkGastricLogic()
  let eligibleValue = 'yes'
  if (gastricOutcome === 'needs_review') eligibleValue = 'pending'

  await sendPreCheckoutMetaObject(collectFormData('eligibility-form'), eligibleValue)
})

async function sendPreCheckoutMetaObject(data, isEligible) {
  console.log("🟣 sendPreCheckoutMetaObject | has-vet-code =", data['has-vet-code'], "| isEligible =", isEligible);

  let appliedVetCode = data['has-vet-code'] === 'no' ? 'COLISHIELD26' : ''
  if (data['has-vet-code'] === 'yes') {
    try {
      const cartRes = await fetch('/cart.js')
      const cart = await cartRes.json()
      if (cart.discount_codes && cart.discount_codes.length > 0) {
        appliedVetCode = cart.discount_codes[0].code
      }
    } catch (err) { console.error('[pre-checkout] Failed to fetch cart:', err) }
  }

  const flatData = {
    is_eligible:             isEligible,
    opt_out:                 data['opt_out'] === 'on' ? 'yes' : 'no',
    stable_name:             data['stable_name'] || '',
    year_of_birth:           data['year_of_birth'] || '',
    has_vet_code:            data['has-vet-code'] || '',
    vet_code:                appliedVetCode,
    horse_age_valid:         data['horse-age-valid'] || '',
    current_health_status:   data['current-health-status'] || '',
    health_details:          data['health_details'] || '',
    no_ongoing_treatment:    data['no-ongoing-treatment'] || '',
    gastric_ulcers:          data['gastric-ulcers'] || '',
    gastric_grade:           data['gastric-grade'] || '',
    gastric_grade4_status:   data['gastric-grade4-status'] || '',
    foaling_7days:           data['foaling-7days'] || '',
    anaesthetic_7days:       data['anaesthetic-7days'] || '',
    no_major_illnesses:      data['no-major-illnesses'] || '',
    no_current_medications:  data['no-current-medications'] || '',
    colic_assessment_needed: data['colic-assessment-needed'] || '',
    colic_number:            data['colic_number'] || '',
    colic_last_date:         data['colic_last_name'] || '',
    colic_vet_call:          data['colic_vet_call'] || '',
    colic_treatment:         data['colic_treatment'] || '',
    location_compatible:     data['location-compatible'] || '',
    intended_usage_allowed:  data['intended-usage-allowed'] || '',
    customer_name:           data['customer_name'] || '',
    customer_email:          data['customer_email'] || '',
    customer_phone:          data['customer_phone'] || '',
    customer_address:        data['customer_address'] || '',
    passport_name:           data['passport_name'] || '',
    microchip_number:        data['microchip_number'] || '',
    passport_number:         data['passport_number'] || '',
    horse_use:               data['horse_use'] || '',
    vet_name:                data['vet_name'] || '',
    practice_name:           data['practice_name'] || '',
    practice_phone:          data['practice_phone'] || '',
    practice_email:          data['practice_email'] || '',
  }

  localStorage.setItem('pre_checkout_data', JSON.stringify(flatData))
  localStorage.setItem('pre_checkout_completed', '1')

  if (data['has-vet-code'] === 'no') {
    console.log("🟣 REDIRECT -> /discount/COLISHIELD26?redirect=/cart  (has-vet-code = no)");
    window.location.href = '/discount/COLISHIELD26?redirect=/cart'
  } else {
    console.log("🟣 REDIRECT -> /cart  (has-vet-code =", data['has-vet-code'], ")");
    window.location.href = '/cart'
  }
}

// ═══════════════════════════════════════════════
//  FIX: opt-out now goes through the same data path.
//  Builds minimal pre_checkout_data so the cart-attribute
//  sync + checkout gate see a completed pre-checkout, and
//  applies COLISHIELD26 as a fallback code so the checkout
//  button is not stuck grey when the customer has no code.
//  A real code the customer types in the cart replaces the
//  fallback and is resolved at checkout (has_vet_code:'yes').
// ═══════════════════════════════════════════════

function handleOptOut() {
  console.log("🟣 OPT-OUT checked -> building minimal pre_checkout_data (FIX)");

  const optOutData = {
    is_eligible:  'no',
    opt_out:      'yes',
    has_vet_code: 'yes',   // 'yes' so checkout resolves whatever code is really in the cart
    vet_code:     ''       // resolved from cart at checkout (real code if entered, else COLISHIELD26)
  };

  localStorage.setItem('pre_checkout_data', JSON.stringify(optOutData));
  localStorage.setItem('pre_checkout_completed', '1');

  console.log("🟣 OPT-OUT -> applying COLISHIELD26 fallback + redirect to /cart");
  window.location.href = '/discount/COLISHIELD26?redirect=/cart';
}

// ────────── Ineligible proceed button ──────────

function proceedWithValidation(eligibleValue) {
  const form = document.getElementById('eligibility-form')
  const { isValid, firstInvalidInput } = validateFormInputs(form)
  if (!isValid) { firstInvalidInput.focus(); return }
  sendPreCheckoutMetaObject(collectFormData('eligibility-form'), eligibleValue)
}

document.getElementById('medical-ineligible-proceed').addEventListener('click', () => {
  const btn = document.getElementById('medical-ineligible-proceed')
  proceedWithValidation(btn.dataset.eligibleValue || 'no')
})

// ────────── Init ──────────

document.addEventListener('DOMContentLoaded', () => {
  const eligibilityForm = document.getElementById('eligibility-form')
  if (eligibilityForm) {
    eligibilityForm.addEventListener('change', checkEligibility)
    checkEligibility()
  }

  const enableTerms = () => {
    const checkbox = document.getElementById('terms_accepted')
    const hint = document.getElementById('tc-link-hint')
    if (checkbox) {
      checkbox.disabled = false
      checkbox.style.borderColor = ''
      checkbox.setAttribute('aria-invalid', false)
      const errorEl = document.getElementById('terms_accepted-error')
      if (errorEl) errorEl.classList.add('hidden')
    }
    if (hint) hint.style.display = 'none'
  }

  const tcLink = document.getElementById('tc-link')
  if (tcLink) tcLink.addEventListener('click', enableTerms)

  const tcHintLink = document.getElementById('tc-link-hint-link')
  if (tcHintLink) tcHintLink.addEventListener('click', enableTerms)

  // FIX: opt-out now runs handleOptOut() instead of a bare redirect
  const optOut = document.getElementById('opt_out')
  if (optOut) {
    optOut.addEventListener('change', (e) => {
      if (e.target.checked) handleOptOut()
    })
  }
})

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', checkEligibility)
} else {
  checkEligibility()
}